import instance from "@/plugins/request";
import { ResponseData } from "@/interface/request";

// 获取区域列表(地图)
export const getAreaList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/area/mapList",
    params
  });
};

// 搜索
export const getSearchList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/area/searchList",
    params
  });
};
// 门店详情
export const getShopDetail = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/area/branchDetails",
    params
  });
};
// 获取店铺列表 -- 废弃(后端说的)
export const getStoreList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/area/branchList",
    params
  });
};
// 获取门店监控主机列表-监控镜头列表-镜头列表
export const getNewCameraList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: `/client/area/storeDetails/${params}`
  });
};

// 获取图片
export const getPhotoList = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "post",
    url: "/client/monitoring/getPreviewImage",
    data
  });
};
//刷新视频图片
export const getRefreshPhotoList = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "post",
    url: "/client/monitoring/getPreviewImageNow",
    data
  });
};
// 获取门店监控主机列表
export const getCameraList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/equipments/list",
    params
  });
};
// 获取门店更多列表
export const getCameraMoreList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/monitoring/getMonitoringList",
    params
  });
};
// 获取门店监控镜头列表
export const getFastShopCameraList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/monitoring/getEquipmentMonitoringList",
    params
  });
};

// 获取(监控主机名)
export const getShopTile = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: `/client/equipments/${params}`
  });
};

// 云台控制
export const cloudControls = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "post",
    url: "/client/monitoring/holder",
    data
  });
};

// 设置预置点
export const editPresetPoint = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "post",
    url: "/web/monitoring/addPreset",
    data
  });
};

// 关闭预置点  (关闭球机选项)
export const closeDefaultPoint = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/web/monitoring/downHolder",
    params
  });
};
// 拼接播放路径
export const getLinkConnect = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "post",
    url: "/client/monitoring/getTranscodingUrl",
    data
  });
};
// 获取截图地址
export const getVideoPhoto = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/system/screenshots",
    params
  });
};
// 判断监控镜头是否支持云台
export const judgeMonitorSupport = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/client/monitoring/ifHolder",
    params
  });
};
// 获取用户信息
export const getMineInfo = (): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/system/user/getPersonalCenterData"
  });
};
// 上传用户头像
export const UpdateUserPhoto = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    headers: {
      "Content-Type": "multipart/form-data"
    },
    method: "post",
    url: "/client/system/getPhoto",
    data
  });
};
// 上传用户头像
// export const updateUserPhoto = (data: unknown): Promise<ResponseData> => {
//   return instance.request({
//     method: 'post',
//     url: `/common/ossUpload`,
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     },
//     data
//   })
// }
// 携带 头像key上传
export const updateMineInfo = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "put",
    url: `/system/user`,
    data
  });
};

// 修改用户头像
// export const modifyUserPhoto = (params: unknown): Promise<ResponseData> => {
//   return instance.request({
//     // headers:{
//     //   "Content-Type":"multipart/form-data"
//     // },
//     method: 'get',
//     url: '/client/system/userHeadPortrait',
//     params
//   })
// }

// 获取用户未读消息条数
export const getNoReadMsg = (): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/web/stationMsg/getUnreadMsgCount"
  });
};

// 销毁转码地址
export const destoryVideoUrl = (): Promise<ResponseData> => {
  return instance.request({
    url: "/web/monitoring/destroyPreviews",
    method: "get"
  });
};
// 获取回放信息
export const getReplayInfo = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "post",
    url: "/web/monitoring/playBack",
    data
  });
};
// 获取内网测试地址
export const getInsideTestUrl = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/web/monitoring/getLANUrl",
    params
  });
};

//上传当前监控点截图
export const updateMonitoringImage = (indexCode: string, data: unknown): Promise<ResponseData | void> => {
  return instance.request({
    method: "post",
    timeout: 10800000,
    url: `/web/monitoring/updateMonitoringImage?indexCode=${indexCode}`,
    data
  });
};

//上传监控点 编辑后的截图
export const updateMonitoringEditImage = (data: unknown): Promise<ResponseData | void> => {
  return instance.request({
    method: "post",
    timeout: 10800000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    url: `/web/monitoring/getScreenshotUrl`,
    data
  });
};

// 修改网点状态 enabled/{indexCode}
export const updateShopStatus = (data: unknown): Promise<ResponseData | void> => {
  return instance.request({
    method: "put",
    url: `/web/area/enabled`,
    data
  });
};

//最新获取视频播放地址
export const getVideoPreviewUrl = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/web/monitoring/play",
    method: "post",
    data
  });
};
// 获取门店监控主机列表-监控镜头列表-巡店
export const getPatrolCameraList = (params1: unknown, params2: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: `/client/area/storeDetails/${params1}/${params2}`
  });
};

/**
 * @function getTaskCompleteDetail
 * @description 获取监控任务完成详情
 * @param 镜头ID/门店ID
 */
export const getTaskCompleteDetail = (params: unknown): Promise<ResponseData | void> => {
  return instance.request({
    url: "/task/currentDetails",
    method: "get",
    params
  });
};

//获取当前镜头或门店是否有任务
export const getMonitorIsTask = (params: unknown): Promise<ResponseData | void> => {
  return instance.request({
    method: "get",
    url: "/task/currentTask",
    params
  });
};
// 获取镜头详情
export const getCameraDetail = (params: unknown): Promise<ResponseData | void> => {
  return instance.request({
    method: "get",
    url: "/task/taskLogDetails",
    params
  });
};
